module.exports = {
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    backendUrlImg: process.env.REACT_APP_BACKEND_URLIMG
  };
  